<template>
  <nav class="items-center relative">
    <div class="w relative">
      <div
        class="items-center inline-block absolute logo cursor-pointer"
        @click="
          link({
            type: 'link',
            link: '/'
          })
        "
      >
        <h1
          class="logo-bd clearfix"
          :style="`background-image:url('${logoUrl}')`"
        >
          {{ title }}
        </h1>
        <h2 class="hidden">{{ title }}</h2>
      </div>
      <ul v-if="navData" class="inline-block text-left w-full h-full nav-list">
        <li
          v-for="data in navData"
          :key="data.id"
          :class="navClassFilter(data)"
          :style="
            navHoverId &&
            navHoverId === data.id &&
            data.type === 'catalogue' &&
            data.children.length !== 0
              ? 'background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAICAYAAAArzdW1AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDowNjFCQzA3OTZBMkYxMUU5OTY3QUQ3MjZENzE2RkVDRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDowNjFCQzA3QTZBMkYxMUU5OTY3QUQ3MjZENzE2RkVDRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjA2MUJDMDc3NkEyRjExRTk5NjdBRDcyNkQ3MTZGRUNEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjA2MUJDMDc4NkEyRjExRTk5NjdBRDcyNkQ3MTZGRUNEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+HItPbAAAAGVJREFUeNpi/H/DmgEJMAJxKBCvBuL/MEEmBlRgDMTOQGyCLIisiBWIg6DsICgfQxHIBGEoWwiIXdEV8QGxJ5rV7lBxuCI/IOZAUwTiB8AUSQOxNQN2YAnEMkxQLzPhUASWBwgwAOR/CNrR5211AAAAAElFTkSuQmCC);'
              : ''
          "
          @click="secondlevelMenu(data)"
          @mouseenter="secondlevelMenu(data, 'true')"
          @mouseleave="secondlevelMenu(data, 'false')"
        >
          <span class="nav-title-cur">{{ data.title }}</span>
          <transition name="nav-item-list">
            <ul
              v-if="
                navHoverId &&
                  navHoverId === data.id &&
                  data.type === 'catalogue' &&
                  data.children.length !== 0
              "
              class="nav-item-list absolute text-center z-10"
              :style="navChildrenStyle(data.children)"
            >
              <li
                v-for="child in data.children"
                :key="child.id"
                :class="
                  child.visible && child.visible === 1
                    ? 'nav-item-list-menu relative'
                    : 'nav-item-list-menu relative hidden'
                "
                @click.stop="secondlevelMenu(data, 'child', child)"
              >
                {{ child.title }}
              </li>
            </ul>
          </transition>
        </li>
      </ul>
      <ul
        class="inline-block land-register-search absolute cursor-pointer clearfix"
      >
        <li
          v-if="!isLogin"
          class="inline-block relative input-search"
          @click="showLoginModal = true"
          @mouseenter="showLoginModal = true"
          @mouseleave="showLoginModal = false"
        >
          <i class="iconfont icon-user imitate-input-icon"></i>
          <img
            class="up-css"
            src="../../../static/images/public/up.png"
            alt="up"
          />
          <transition name="isLogin">
            <ul
              v-if="showLoginModal"
              class="personal-information leading-loose"
            >
              <li
                class="personal-information-menu px-0 text-center cursor-point"
                @click="loginRegister('登录')"
              >
                登录
              </li>
              <li
                class="personal-information-menu px-0 text-center cursor-point"
                @click="loginRegister('注册')"
              >
                注册
              </li>
            </ul>
          </transition>
        </li>
        <li
          v-else
          class="inline-block text-right relative user-name clearfix"
          @click="showPersonalInformation = true"
          @mouseenter="showPersonalInformation = true"
          @mouseleave="showPersonalInformation = false"
        >
          <span
            :class="
              showPersonalInformation
                ? 'c-active user-name-text'
                : 'user-name-text'
            "
            >{{ client.nickname || '' }}</span
          >
          <img
            class="up-css top-26"
            src="../../../static/images/public/up.png"
            alt="up"
          />
          <transition name="personal-information">
            <ul
              v-if="showPersonalInformation"
              class="personal-information leading-loose text-center"
            >
              <li
                :class="
                  meActive === item.id
                    ? 'personal-information-menu cursor-pointer text-left active'
                    : 'personal-information-menu cursor-pointer text-left'
                "
                v-for="item in personalInformation"
                :key="item.id"
                :id="item.id"
                @click="dropdownClick(item)"
              >
                {{ item.title }}
              </li>
            </ul>
          </transition>
        </li>
        <li class="vertical">|</li>
        <li
          class="inline-block relative input-search"
          @click="showSearch = true"
        >
          <i class="iconfont icon-search imitate-input-icon"></i>
          <img
            class="up-css"
            src="../../../static/images/public/up.png"
            alt="up"
          />
        </li>
      </ul>
      <SearchBar
        :showSearch="showSearch"
        @closeSearch="showSearch = false"
      ></SearchBar>
      <LoginBar
        :show.sync="showMask"
        :isAuthorize="isAuthorize"
        :type="loginType"
      ></LoginBar>
      <Masker :show.sync="showMask" style="z-index:102;"></Masker>
    </div>

    <div
      v-if="navHoverId"
      class="nav-item-list bgc-transparent-nav-list absolute pin-x text-center"
    ></div>
  </nav>
</template>

<script>
import link from '@/core/mixins/link'
import LoginBar from '@/components/common/LoginBar'
import Masker from '@/components/common/Mask'
import SearchBar from '@/components/search/SearchBar'
import EventBus from '@/core/eventbus'

export default {
  name: 'header-nav',
  components: {
    LoginBar,
    Masker,
    SearchBar
  },
  mixins: [link],
  data() {
    return {
      showMask: false,
      showSearch: false,
      showPersonalInformation: false,
      personalInformation: [
        {
          id: 'me',
          title: '个人中心',
          link: '/me'
        },
        {
          id: 'logout',
          title: '退出系统',
          link: '#'
        }
      ],
      meActive: null,
      navHoverId: null,
      showLoginModal: false,
      loginType: false
    }
  },
  watch: {
    client() {
      this.getClient()
    },
    subscriber() {
      this.getClient()
    }
  },
  computed: {
    logoUrl() {
      let url =
        this.$store.getters['HomeStore/logoUrl'] ||
        '/img/texture-bg.22ca156b.jpg'
      return url
    },
    title() {
      return this.$store.getters['HomeStore/title']
    },
    navData() {
      let data = this.$store.getters['CategoriesStore/categories']
      if (!data) {
        return
      }
      function visibleFilter(val) {
        let res
        res = val.filter(item => {
          if (item.children && item.children.length !== 0) {
            item.children = visibleFilter(item.children)
          }
          return item.visible === 1
        })
        return res
      }
      data = visibleFilter(data)
      return data
    },
    client() {
      let data = this.$store.getters['SubscriberStore/client']
      return data
    },
    subscriber() {
      let data = this.$store.getters['SubscriberStore/subscriber']
      return data
    },
    isLogin() {
      return (
        this.subscriber &&
        this.client &&
        this.subscriber.open_id &&
        this.client.mobile
      )
    },
    isAuthorize() {
      return this.client && this.subscriber && this.subscriber.open_id
    },
    navActiveId() {
      let category = this.$route.params.category || this.$route.meta.id // 从地址栏拿栏目的ID
      let breadcrumb = this.$store.getters['CategoriesStore/breadcrumb'](
        category
      )
      // 从breadcrumb第二项的ID 取 导航栏被选中的数据
      let navActive
      if (!breadcrumb || !breadcrumb[1]) {
        return
      }
      navActive = breadcrumb[1].id
      return navActive
    }
  },
  mounted() {
    let _this = this
    this.getClient()
    EventBus.$on('showModal', function() {
      _this.$set(_this, 'showMask', true)
    })

    if (!sessionStorage.getItem('wxOpenId')) {
      this.$store.dispatch('SubscriberStore/logout') // 删除个人信息
    }
  },
  methods: {
    navChildrenStyle(data) {
      let style = ''
      style += `margin-left: -${(119 * data.length) / 2}px;`
      return style
    },
    loginRegister(type) {
      this.$swal.queue({
        position: 'top-end',
        type: 'success',
        showConfirmButton: false,
        timer: 3000
      })
      this.loginType = type
      this.showMask = true
    },
    navClassFilter(data) {
      let thisClass = ''
      if (this.navActiveId) {
        thisClass += 'show-cur'
      }
      thisClass =
        this.navActiveId === data.id
          ? `nav-item inline-block text-center cursor-pointer relative active`
          : `nav-item inline-block text-center cursor-pointer relative`
      return thisClass
    },
    getClient() {
      // 已微信授权时
      if (this.isAuthorize) {
        // 用户微信已授权，无手机号
        if (this.isLogin) {
          this.showMask = false // 关闭弹出框
          let category = this.$route.params.category || this.$route.meta.id // 从地址栏拿栏目的ID
          this.$set(this, 'meActive', category)
        }
      }
    },
    secondlevelMenu(data, type, child) {
      if (
        type &&
        type === 'true' &&
        data.type === 'catalogue' &&
        data.children.length !== 0
      ) {
        // 鼠标经过，有下级菜单的显示
        this.navHoverId = data.id
      } else if (type && type === 'false') {
        // 鼠标离开，有下级菜单的隐藏
        this.navHoverId = null
      } else if (type && type === 'child') {
        // 下级菜单被点击，上级加active并跳转页面
        let newData = child
        newData.category = child.id
        this.link(newData)
      } else if (!type) {
        let linkData = data
        linkData.category = data.id
        if (data.type === 'catalogue') {
          linkData.firstChildCategory = data.children[0].id
        }
        // 没有下级菜单的 被点击，加active
        this.link(linkData)
      }
    },
    dropdownClick(item) {
      let _this = this
      if (item.id === 'logout') {
        this.$swal({
          text: '你确定要退出吗?',
          showCancelButton: true,
          confirmButtonText: '退出',
          cancelButtonText: '取消'
        }).then(res => {
          if (res.value) {
            _this.$store.dispatch('SubscriberStore/logout') // 删除个人信息
            if (this.$route.meta.id === 'me')
              //如果在个人中心退出则返回首页
              this.link({
                type: 'link',
                link: '/'
              })
          }
        })
      } else {
        this.link({
          type: 'link',
          link: item.link,
          category: item.category
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.nav-item-list-enter-active,
.personal-information-enter-active {
  transition: all 0.35s;
  -moz-transition: all 0.35s; /* Firefox 4 */
  -webkit-transition: all 0.35s; /* Safari 和 Chrome */
  -o-transition: all 0.35s; /* Opera */
}

.nav-item-list-leave-active,
.personal-information-leave-active {
  transition: all 0.35s;
  -moz-transition: all 0.35s; /* Firefox 4 */
  -webkit-transition: all 0.35s; /* Safari 和 Chrome */
  -o-transition: all 0.35s; /* Opera */
}

.nav-item-list-enter,
.nav-item-list-leave-to {
  height: 0;
  opacity: 0;
}

.personal-information-enter,
.personal-information-leave-to {
  opacity: 0;
}

.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
nav {
  z-index: 2;
  height: 85px;
  background-color: $c-nav-bgc;
}
.logo {
  top: 13px;
  left: 24px;
  z-index: 1;
}
.logo-bd {
  width: 412px;
  height: 58px;
  background-image: url('../../../static/images/logo.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-indent: -9999px;
  font-size: 0;
}
.nav-list {
  color: $c-nav-font;
  font-size: 16px;
  padding: 0 0 0 495px;
}
.nav-item {
  padding: 50px 16px 17px 16px;
  background-repeat: no-repeat;
  background-image: url('');
  background-size: 9px 9px;
  background-position: 48% 100%;
  &:hover,
  &.active {
    color: $c-white;
  }
}

.nav-item-list {
  white-space: nowrap;
  width: auto;
  height: 50px;
  line-height: 50px;
  bottom: -50px;
  left: 50%;
  font-size: 13.52px;
  font-weight: 200;
  color: $c-white;
  // margin-left: -205px;
  a {
    color: $c-white;
  }
}
.bgc-transparent-nav-list {
  z-index: 1;
  left: 0;
  right: 0;
  background-color: $c-transparent-nav-list; // fffc0d
}
.nav-item-list-menu {
  color: $c-white;
  display: inline-block;
  padding: 0px 32px;
  &::after {
    content: '|';
    height: 14px;
    position: absolute;
    right: 0;
    top: 35%;
    color: $c-transparent;
    border-right: 1px solid $c-white;
  }
  &:last-child {
    &::after {
      border: 0 none;
    }
  }
  &:hover {
    color: $c-nav-font;
  }
}
.land-register-search {
  color: $c-nav-font;
  bottom: 0;
  right: 20px;
  font-size: 18px;
  > li {
    float: left;
    padding: 0 0 5px 15px;
    vertical-align: middle;
    &:hover {
      color: $c-white !important;
    }
  }
  .vertical {
    padding: 0;
    opacity: 0.5;
    line-height: 40px;
  }
  .up-css {
    padding: 17px 14px 17px 11px;
  }
  .top-26 {
    top: 26px;
  }
}

.imitate-input-icon {
  color: $c-nav-font;
  font-size: 15px;
}
//个人中心
.user-name {
  color: $c-nav-font;
  font-size: 16px;
  min-width: 100px;
  .user-name-text {
    float: left;
    width: 50px;
    line-height: 38px;
    overflow: hidden;
    -o-text-overflow: ellipsis; /* Opera 9-10 */
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.personal-information {
  position: absolute;
  top: 45px;
  right: 0;
  width: 100%;
  color: $c-nav-font;
  background-color: $c-black;
  font-size: 14px;
  line-height: 35px;
  z-index: 102;
  .personal-information-menu {
    padding: 0px 20px;
    border-bottom: 1px solid $c-login-up-border;
    &:hover {
      color: $c-white !important;
    }
    &.active {
      color: $c-white !important;
      background-color: $c-login-up-border;
    }
  }
}
.c-active {
  color: $c-white !important;
}
@media only screen and (min-width: 736px) {
}
@media only screen and (max-width: 735px) {
  nav {
    display: none;
  }
}
</style>
